import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.is-array";
import _classCallCheck from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Table/table';
import stylesGrid from '@patternfly/react-styles/css/components/Table/table-grid';
import { getOUIAProps } from '@patternfly/react-core';
import { DropdownDirection, DropdownPosition } from '@patternfly/react-core/dist/js/components/Dropdown/dropdownConstants';
import inlineStyles from '@patternfly/react-styles/css/components/InlineEdit/inline-edit';
import { css } from '@patternfly/react-styles';
import { Provider } from './base';
import { BodyCell } from './BodyCell';
import { HeaderCell } from './HeaderCell';
import { RowWrapper } from './RowWrapper';
import { BodyWrapper } from './BodyWrapper';
import { toCamel } from './utils';
import { calculateColumns } from './utils/headerUtils';
export var TableGridBreakpoint;

(function (TableGridBreakpoint) {
  TableGridBreakpoint["none"] = "";
  TableGridBreakpoint["grid"] = "grid";
  TableGridBreakpoint["gridMd"] = "grid-md";
  TableGridBreakpoint["gridLg"] = "grid-lg";
  TableGridBreakpoint["gridXl"] = "grid-xl";
  TableGridBreakpoint["grid2xl"] = "grid-2xl";
})(TableGridBreakpoint || (TableGridBreakpoint = {}));

export var TableVariant;

(function (TableVariant) {
  TableVariant["compact"] = "compact";
})(TableVariant || (TableVariant = {}));

export var SortByDirection;

(function (SortByDirection) {
  SortByDirection["asc"] = "asc";
  SortByDirection["desc"] = "desc";
})(SortByDirection || (SortByDirection = {}));

export var TableContext = React.createContext({
  headerData: null,
  headerRows: null,
  rows: []
});
export var Table = /*#__PURE__*/function (_React$Component) {
  _inherits(Table, _React$Component);

  var _super = _createSuper(Table);

  function Table() {
    var _this;

    _classCallCheck(this, Table);

    _this = _super.apply(this, arguments);

    _this.isSelected = function (row) {
      return row.selected === true;
    };

    _this.areAllRowsSelected = function (rows) {
      if (rows === undefined || rows.length === 0) {
        return false;
      }

      return rows.every(function (row) {
        return _this.isSelected(row) || row.hasOwnProperty('parent') && !row.showSelect;
      });
    };

    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.onRowEdit && process.env.NODE_ENV !== 'production' && !Table.hasWarnBeta) {
        // eslint-disable-next-line no-console
        console.warn('You are using a beta component feature (onRowEdit). These api parts are subject to change in the future.');
        Table.hasWarnBeta = true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          ariaLabel = _a['aria-label'],
          caption = _a.caption,
          header = _a.header,
          className = _a.className,
          gridBreakPoint = _a.gridBreakPoint,
          onSort = _a.onSort,
          onSelect = _a.onSelect,
          canSelectAll = _a.canSelectAll,
          sortBy = _a.sortBy,
          children = _a.children,
          actions = _a.actions,
          actionResolver = _a.actionResolver,
          areActionsDisabled = _a.areActionsDisabled,
          onCollapse = _a.onCollapse,
          onExpand = _a.onExpand,
          onRowEdit = _a.onRowEdit,
          rowLabeledBy = _a.rowLabeledBy,
          dropdownPosition = _a.dropdownPosition,
          dropdownDirection = _a.dropdownDirection,
          contentId = _a.contentId,
          expandId = _a.expandId,
          variant = _a.variant,
          rows = _a.rows,
          cells = _a.cells,
          bodyWrapper = _a.bodyWrapper,
          rowWrapper = _a.rowWrapper,
          borders = _a.borders,
          role = _a.role,
          ouiaId = _a.ouiaId,
          ouiaSafe = _a.ouiaSafe,
          isStickyHeader = _a.isStickyHeader,
          props = __rest(_a, ['aria-label', "caption", "header", "className", "gridBreakPoint", "onSort", "onSelect", "canSelectAll", "sortBy", "children", "actions", "actionResolver", "areActionsDisabled", "onCollapse", "onExpand", "onRowEdit", "rowLabeledBy", "dropdownPosition", "dropdownDirection", "contentId", "expandId", "variant", "rows", "cells", "bodyWrapper", "rowWrapper", "borders", "role", "ouiaId", "ouiaSafe", "isStickyHeader"]);

      if (!ariaLabel && !caption && !header && role !== 'presentation') {
        // eslint-disable-next-line no-console
        console.error('Table: Specify at least one of: header, caption, aria-label');
      }

      var headerData = calculateColumns(cells, {
        sortBy: sortBy,
        onSort: onSort,
        onSelect: onSelect,
        canSelectAll: canSelectAll,
        allRowsSelected: onSelect ? this.areAllRowsSelected(rows) : false,
        actions: actions,
        actionResolver: actionResolver,
        areActionsDisabled: areActionsDisabled,
        onCollapse: onCollapse,
        onRowEdit: onRowEdit,
        onExpand: onExpand,
        rowLabeledBy: rowLabeledBy,
        expandId: expandId,
        contentId: contentId,
        dropdownPosition: dropdownPosition,
        dropdownDirection: dropdownDirection,
        firstUserColumnIndex: [onCollapse, onSelect].filter(function (callback) {
          return callback;
        }).length
      });
      var table = React.createElement(TableContext.Provider, {
        value: {
          headerData: headerData,
          headerRows: null,
          rows: rows
        }
      }, header, React.createElement(Provider, Object.assign({}, props, {
        "aria-label": ariaLabel,
        renderers: {
          body: {
            wrapper: bodyWrapper || BodyWrapper,
            row: rowWrapper || RowWrapper,
            cell: BodyCell
          },
          header: {
            cell: HeaderCell
          }
        },
        columns: headerData,
        role: role,
        className: css(styles.table, gridBreakPoint && stylesGrid.modifiers[toCamel(gridBreakPoint).replace(/-?2xl/, '_2xl')], styles.modifiers[variant], (onCollapse && variant === TableVariant.compact || onExpand) && styles.modifiers.expandable, variant === TableVariant.compact && borders === false ? styles.modifiers.noBorderRows : null, isStickyHeader && styles.modifiers.stickyHeader, className)
      }, getOUIAProps(Table.displayName, ouiaId, ouiaSafe)), caption && React.createElement("caption", null, caption), children));

      if (onRowEdit) {
        return React.createElement("form", {
          className: css(inlineStyles.inlineEdit)
        }, table);
      }

      return table;
    }
  }]);

  return Table;
}(React.Component);
Table.displayName = 'Table';
Table.hasWarnBeta = false;
Table.defaultProps = {
  children: null,
  className: '',
  variant: null,
  borders: true,
  rowLabeledBy: 'simple-node',
  expandId: 'expandable-toggle',
  contentId: 'expanded-content',
  dropdownPosition: DropdownPosition.right,
  dropdownDirection: DropdownDirection.down,
  header: undefined,
  caption: undefined,
  'aria-label': undefined,
  gridBreakPoint: TableGridBreakpoint.gridMd,
  role: 'grid',
  canSelectAll: true,
  ouiaSafe: true,
  isStickyHeader: false
};